import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	updateErrorTitle: {
		id: 'business-categories.services.update-category.update-error-title',
		defaultMessage: "We couldn't update the category",
		description: 'Title in flag message informing the user that renaming the category failed',
	},
	updateErrorMessage: {
		id: 'business-categories.services.update-category.update-error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message when rename fails',
	},
	updateSuccessTitle: {
		id: 'business-categories.services.update-category.update-success-title',
		defaultMessage: 'Category updated',
		description: 'Title in flag message informing the user that renaming the category succeeded',
	},
	updateSuccessMessage: {
		id: 'business-categories.services.update-category.update-success-message',
		defaultMessage: 'Category has been updated successfully.',
		description: 'Flag message when category successfully renamed',
	},
});
